import React, { useMemo, useState } from "react";
import {
  InnerContainer,
  LeftCol,
  MainContainer,
  MainHeading,
  RightCol,
} from "./styles";
import AddressPaymentDetails from "../AddressPaymentDetails";
import OrderSummary from "../OrderSummary";

const Checkout = () => {
  const [useDefaultShippingAddress, setUseDefaultShippingAddress] = useState(true);
  const [orderShippingAddress, setOrderShippingAddress] = useState(null);
  const [hasSavedDefault, setHasSavedDefault] = useState(false);

  const shippingSelection = useMemo(
    () => ({
      useDefaultShippingAddress,
      setUseDefaultShippingAddress,
      orderShippingAddress,
      setOrderShippingAddress,
      hasSavedDefault,
      setHasSavedDefault,
    }),
    [useDefaultShippingAddress, orderShippingAddress, hasSavedDefault]
  );

  return (
    <MainContainer>
      <MainHeading>{`Checkout`}</MainHeading>
      <InnerContainer>
        <LeftCol>
          <AddressPaymentDetails shippingSelection={shippingSelection} />
        </LeftCol>
        <RightCol>
          <OrderSummary shippingSelection={shippingSelection} />
        </RightCol>
      </InnerContainer>
    </MainContainer>
  );
};

export default Checkout;
